import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#7B7DE5", // 🔥 from your CSS
        },
        secondary: {
            main: "#22C55E",
        },
        background: {
            default: "#FCFCFC",
            paper: "#FFFFFF",
        },
        text: {
            primary: "#000000",
            secondary: "#0000008C",
        },
        divider: "#E8E8E8",
    },

    shape: {
        borderRadius: 8,
    },

    typography: {
        fontFamily: `"SF Pro Display", sans-serif`, // 🔥 your font
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
        button: {
            textTransform: "none",
            fontWeight: 500,
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#FCFCFC",
                },
            },
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    border: "1px solid #E8E8E8",
                    boxShadow: "none",
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: "6px 16px",
                },
            },
        },

        MuiTextField: {
            defaultProps: {
                size: "small",
                variant: "outlined",
            },
        },

        MuiInput: {
            defaultProps: {
                size: "small",
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    backgroundColor: "#FAFAF9",
                },
            },
        },

        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    borderColor: "#7B7DE5",
                    color: "#7B7DE5",
                },
            },
        },

        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        backgroundColor: "#7B7DE5",
                        color: "#fff",
                    },
                },
            },
        },
    },
});

export default theme;